import { render, staticRenderFns } from "./base-textarea.vue?vue&type=template&id=1d094f9d&scoped=true"
import script from "./base-textarea.vue?vue&type=script&lang=ts"
export * from "./base-textarea.vue?vue&type=script&lang=ts"
import style0 from "./base-textarea.vue?vue&type=style&index=0&id=1d094f9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d094f9d",
  null
  
)

export default component.exports